// Generated by scripts/build-ui-icons.mjs.
export { Calculator as default } from "../ui/glyphs-2";
